import { Dispatch, ReactNode, SetStateAction } from "react"
import {
  MODELO_IMPUESTO,
  ModeloImpuestoType,
} from "../../../../../api/Types/ModeloImpuesto"
import { HandleTabs } from "../DetalleImpuestos"
import { DetalleImpuestoTabName } from "../components/DetalleImpuestoTabName"
import { Modelo111 } from "../components/Modelo111/Modelo111"
import { Modelo115 } from "../components/Modelo115/Modelo115"
import { Modelo180 } from "../components/Modelo180/Modelo180"
import { Modelo190 } from "../components/Modelo190/Modelo190"
import Modelo303 from "../components/Modelo303/Modelo303"
import { Modelo347 } from "../components/Modelo347/Modelo347"
import { Modelo349 } from "../components/Modelo349/Modelo349"
import { Modelo390 } from "../components/Modelo390/Modelo390"

interface DetalleImpuestosTabsProps {
  model: ModeloImpuestoType
  tabTitle: {
    element: JSX.Element
    disabled: boolean
  }
  tabBody: ReactNode
}
export const DETALLE_IMPUESTOS_TABS = (
  handleTabs: HandleTabs,
  setModel: Dispatch<SetStateAction<ModeloImpuestoType>>
): Array<DetalleImpuestosTabsProps> => [
  {
    model: MODELO_IMPUESTO.MODELO_111,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_111,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo111 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_115,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_115,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo115 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_180,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_180,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo180 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_190,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_190,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo190 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_303,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_303,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo303 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_347,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_347,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo347 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_349,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_349,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo349 props={handleTabs} />,
  },
  {
    model: MODELO_IMPUESTO.MODELO_390,
    tabTitle: {
      element: DetalleImpuestoTabName({
        modelNumber: MODELO_IMPUESTO.MODELO_390,
        t: handleTabs.t,
        setModel,
      }),
      disabled: false,
    },
    tabBody: <Modelo390 {...handleTabs} />,
  },
]
